import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
var PaySuccessComponent = /** @class */ (function () {
    function PaySuccessComponent(route, router, rest, spinner, app) {
        this.route = route;
        this.router = router;
        this.rest = rest;
        this.spinner = spinner;
        this.app = app;
        this.invoice_uuid = "";
        this.isEmptyCart = false;
        this.my_uuid = "";
        this.isCancelled = false;
    }
    PaySuccessComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // if (Number(params["id"])) {
                //   const inv = params["id"];
                //   if (inv.length > 10) {
                //     this.router.navigate(["/404"]);
                //   } else {
                //     this.checkPayment(params["id"]);
                //   }
                // } else {
                //   this.router.navigate(["/404"]);
                // }
                this.checkPayment(params["id"]);
                return [2 /*return*/];
            });
        }); });
        this.route.queryParams.subscribe(function (query) {
            if (query.cancel == true || query.cancel == "true") {
                _this.isCancelled = true;
            }
        });
    };
    PaySuccessComponent.prototype.checkPayment = function (invoice_uuid) {
        var _this = this;
        var data = { invoice_uuid: invoice_uuid };
        this.rest.checkPayment(data).subscribe(function (result) {
            _this.my_uuid = result.id;
            _this.status = result.status;
            _this.invoice_uuid = result.invoice_uuid;
            _this.message = result.message;
            _this.message_cn = result.message_cn;
            _this.message_fr = result.message_fr;
        });
    };
    return PaySuccessComponent;
}());
export { PaySuccessComponent };
